var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVhf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1E81F7",
    width: "40px",
    height: "40px",
    viewBox: "0 1 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.27 14.91a.554.554 0 0 1-.392-.946 6.201 6.201 0 1 0-8.763 0 .554.554 0 1 1-.784.784 7.31 7.31 0 1 1 10.331 0 .55.55 0 0 1-.392.162zm-2.16-2.159a.554.554 0 0 1-.392-.946 3.142 3.142 0 1 0-4.444 0 .554.554 0 0 1-.783.784 4.25 4.25 0 1 1 6.011 0 .553.553 0 0 1-.391.162zm-1.117 3.32H9.05V10.99a1.511 1.511 0 1 0-1.108 0v5.081H7a.554.554 0 0 0 0 1.109h2.993a.554.554 0 0 0 0-1.109z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVhf);
export default __webpack_public_path__ + "static/media/vhf.d53abf08312aaded034dcbaacf45026d.svg";
export { ForwardRef as ReactComponent };